'use es6';

import tinymce from 'tinymce';
import { __HS_EMOJI } from '../constants/plugins';
import { addControls } from './controls';
export const HS_EMOJI = __HS_EMOJI;
function emojiPlugin(editor) {
  addControls(editor, HS_EMOJI);
}
tinymce.PluginManager.add(HS_EMOJI, emojiPlugin);